require("writing/questions/fitb_answer_box.scss");

class FITBAnswerBox extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onAnswersChange(e) {
		var newAnswers = _.clone(this.props.answers);

		var text = e.target.value;

		if (text.length > MAX_ANSWER_LEN) {
			return;
		}

		var parts = text.split(/[,\n]/g).map(x => x.trim());

		if (parts.length > 1) {
			var lastPart = parts.pop()

			newAnswers.pop(); // Remove the working answer
			newAnswers = _.uniq(newAnswers.concat(parts.concat(_.reject(parts, _.isEmpty))));
			newAnswers.push(lastPart) // Allow last part to be non-unique

		} else if (newAnswers.length == 0) {
			newAnswers = [text];

		} else {
			// Update the last element
			newAnswers[newAnswers.length - 1] = text;
		}

		this.props.updateAnswers(newAnswers);
	}
	onAnswersBlur() {
		var newAnswers = _.uniq(_.reject(this.props.answers.map(x => x.trim()), _.isEmpty));

		if ((_.last(newAnswers) || "").length < MAX_ANSWER_LEN) {
			newAnswers.push("");			
		}
		this.props.updateAnswers(newAnswers);
	}

	removeAnswer(text) {
		var newAnswers = _.without(this.props.answers, text)
		this.props.updateAnswers(newAnswers);
	}

	render() {
		var answerOps = _.clone(this.props.answers);
		var workingAnswer = answerOps.pop() || "";

		var answerBubbles = answerOps.map((answer, index) => {
			return (
				<span className="answerOp" key={ index }
					onClick={ this.removeAnswer.bind(this, answer) }>
					{ answer }
				</span>
			);
		});

		if (workingAnswer.length == MAX_ANSWER_LEN) {
			var errorDisplay = (
				<p className="smallText errorRed">
					Answers are for fill-in-the-blank questions, and shouldn't be too long
				</p>
			)
		}

		var rowCount = answerBubbles.length ? 1 : 2;

		return (
			<div className="FITBAnswerBox">
				{ answerBubbles }
				<textarea className="questionAnswersInput"
					onChange={ this.onAnswersChange } value={ workingAnswer }
					onBlur={ this.onAnswersBlur }
					rows={ rowCount } className="form-control"
					placeholder="Your answers..." />

				{ errorDisplay }
			</div>
		);
	}
}

const MAX_ANSWER_LEN = 50;


FITBAnswerBox.propTypes = StrictPropTypes({
	answers: PropTypes.array.isRequired,
	updateAnswers: PropTypes.func.isRequired
});

module.exports = FITBAnswerBox;


// WEBPACK FOOTER //
// ./modules/components/writing/questions/FITBAnswerBox.js